const Accordion = {
    init() {
        if (customElements.get('accordion-component')) return;
        class AccordionComponent extends HTMLElement {
            connectedCallback() {
                const container = this.closest('.accordion-container-js');
                const toggle = this.querySelector('.accordion-toggle');
                const content = this.querySelector('.accordion-content');
                const contentInner = this.querySelector('.accordion-content-inner');

                if (!toggle || !content || !contentInner) return;

                if (content.getAttribute('aria-hidden') === 'false') {
                    content.style.height = contentInner.offsetHeight + 'px';
                    this.setAttribute('open', '');
                }

                toggle.addEventListener('click', () => {
                    const isOpen = content.getAttribute('aria-hidden') === 'false';

                    if (isOpen) {
                        content.setAttribute('aria-hidden', 'true');
                        content.style.height = '0px';
                        this.removeAttribute('open');
                        return;
                    }

                    if (container) {
                        const openContent = container.querySelector('.accordion-content[aria-hidden="false"]');
                        if (openContent) {
                            const openAccordion = openContent.closest('accordion-component');
                            openContent.setAttribute('aria-hidden', 'true');
                            openContent.style.height = '0px';
                            if (openAccordion) {
                                openAccordion.removeAttribute('open');
                            }
                        }
                    }

                    content.setAttribute('aria-hidden', 'false');
                    content.style.height = contentInner.offsetHeight + 'px';
                    this.setAttribute('open', '');
                });
            }
        }

        customElements.define('accordion-component', AccordionComponent);
    }
};

export default Accordion;
